/**
 * #469 — the side judge's card, IFMA v3.057.
 *
 * The judge awards the round AS FOUGHT (§29.2.3): 10 to the better athlete,
 * and 9, 8 or 7 to the other (small margin, large margin, total domination),
 * or 10 each when they are even. Each Warning then takes 1 point (§29.2.5).
 * LMF: every judge records every Warning that the referee gives, and applies
 * it. The card stores the points AFTER the Warnings and the outcome of the
 * round as fought. The server checks the same rules (routes/scoring.ts).
 */
import type { RoundOutcome } from '../utils/roundSuggestion';

export type Corner = 'red' | 'blue';
// #661 — one declaration of the outcome of a round: utils/roundSuggestion.ts (the mirror of the backend).
export type { RoundOutcome };

/** The point buttons: the round as fought, before the Warnings. */
export const FOUGHT_VALUES = [7, 8, 9, 10] as const;

/** The outcome that the round as fought gives. */
export function outcomeOf(redFought: number, blueFought: number): RoundOutcome {
  if (redFought === blueFought) return 'even';
  return redFought > blueFought ? 'red' : 'blue';
}

/** A tap on a point button. A value under 10 gives the other athlete the 10:
 *  one athlete always has 10 (the ten-point must system). */
export function tapPoints(corner: Corner, value: number, current: { red: number; blue: number }): { red: number; blue: number } {
  const next = { ...current, [corner]: value };
  if (value < 10) next[corner === 'red' ? 'blue' : 'red'] = 10;
  return next;
}

/** A stored card back to the round as fought: the points plus the Warnings.
 *  A card from before #469 can hold a Warning that the judge did not deduct,
 *  so the value is kept inside the legal band. */
export function foughtFromCard(points: number | null | undefined, warnings: number | null | undefined): number {
  const v = (points ?? 10) + (warnings ?? 0);
  return Math.min(10, Math.max(7, v));
}
